export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/render.worker.24f7f12d.js");
}
